import { Input, Directive } from '@angular/core';
import { Partition } from '@classes/simulation/partition';

@Directive()
export class PartitionsSunburstBase {
    @Input() mainPartition: Partition;
    @Input() selected: Partition;
    @Input() selectedCodes: string[];
    @Input() year: number;
    @Input() chartSize: number;
    @Input() isGrey: boolean;

    constructor() { }
}
